import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Public Roadmap | Canny';
const Description =
  'Make your roadmap public to show off what your team is working on and collect valuable feedback.';
const Image = 'https://canny.io/images/canny-social.png';
const PublicRoadmapUrl = 'https://canny.io/use-cases/public-roadmap';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${PublicRoadmapUrl}#webpage`,
    url: PublicRoadmapUrl,
    name: 'Public Roadmap - Canny',
    description:
      "Share your product vision and upcoming features with Canny's public roadmap to increase transparency and engage your users.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${PublicRoadmapUrl}#capabilities`,
    'Public Roadmap Capabilities',
    [
      {
        name: 'Showcase Product Vision',
        description:
          "Share your long-term product plans to keep users informed about what's coming next.",
      },
      {
        name: 'Collect Feedback on Roadmap Items',
        description:
          'Enable customers to engage with roadmap items by voting and commenting on planned features.',
      },
      {
        name: 'Increase Transparency with Customers',
        description:
          'Build trust by making development priorities visible and explaining your decision-making process.',
      },
      {
        name: 'Close the Feedback Loop',
        description:
          'Notify users when roadmap items progress, ensuring they see their input reflected in your product.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Public Roadmap', item: PublicRoadmapUrl },
  ]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: PublicRoadmapUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
